import React from 'react';
import Header from './Header';
import Rockets from './Rockets';

const Home = () => {
    return (
        <div>
            <Header />
            <Rockets/>
        </div>
    );
};

export default Home;